import React from 'react'
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const BarChart = ({bardata}) => {
    const chartData = {
        labels: [ 'August' , "September",'October' , "November" , "December"], // X-axis labels
        datasets: [
            {
                label: "Atto",
                data: [12, 9, 3, 5, 2],
                backgroundColor: "#002A5D", // Light blue color for bars
                borderColor: "#001C4C", // Darker shade of the background color
                borderWidth: 1,
            },
            {
                label: "Seal",
                data: [22, 19, 3, 5, 2],
                backgroundColor: "#ffa600", // Yellow color for bars
                borderColor: "#cc8400", // Darker shade of the background color
                borderWidth: 1,
            },
            // {
            //     label: "Shark",
            //     data: [1, 9, 3, 7, 2],
            //     backgroundColor: "#640c0c", // Dark red color for bars
            //     borderColor: "#4e0a0a", // Darker shade of the background color
            //     borderWidth: 1,
            // },
            
            
        ],
    };

    // Chart Options
    const chartOptions = {
        responsive: true,
        indexAxis: 'y', // Change to horizontal orientation
        plugins: {
            legend: {
                position: "top", // Position of the legend
            },
            title: {
                display: true,
                text: "Total Expression of Interest", // Chart title
            },
        },
        scales: {
            x: { // Ensure X-axis starts at 0 for horizontal orientation
                beginAtZero: true,
            },
        },
    };
    return <Bar data={chartData} options={chartOptions} />

}

export default BarChart

